import React, { forwardRef } from 'react'
import MatrixTimelinePanel from 'matrix-react-sdk/lib/components/structures/TimelinePanel'

const TimelinePanel = forwardRef((props, ref) => {
  return <MatrixTimelinePanel {...props} jumpToReadMarker ref={ref} />
})

export default TimelinePanel
